// External Dependencies
import { ReviewPurchaseOrderRequest } from '@presto-assistant/api_types/api/admin/purchaseOrder';
import { useMutation, useQueryClient } from '@tanstack/react-query';

// Internal Dependencies
import { prestoAdminApiClient } from 'utils/api/apiClient';

export const useDownloadPurchaseOrder = () => {
  return useMutation({
    mutationFn: (purchaseOrderId: string) =>
      prestoAdminApiClient.v1.purchaseOrders.downloadPurchaseOrder({
        params: { purchaseOrderId },
      }),
  });
};

interface ReviewPurchaseOrderParams {
  body: ReviewPurchaseOrderRequest['body'];
  params: ReviewPurchaseOrderRequest['params'];
}

export const useReviewPurchaseOrder = (estimateId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      body,
      params,
    }: ReviewPurchaseOrderParams) =>
      prestoAdminApiClient.v1.purchaseOrders.reviewPurchaseOrder({
        body,
        params,
      }),
    onSuccess: async () => {
      // invalidate the invoice show data cache
      await queryClient.invalidateQueries({ queryKey: ['getEstimate', estimateId] });
    },
  });
};
